<template>
  <div class="min-h-screen w-full min-w-0 bg-[#f8f9fa] dark:bg-gray-950">
    <GovUtilityBar fixed @utility-action="goToLogin" />

    <div class="w-full min-w-0 max-w-full flex items-center justify-center px-3 sm:px-4 pt-20 sm:pt-24 pb-10">
      <p class="text-xs sm:text-sm text-gray-700 dark:text-gray-300">Opening teacher login…</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import GovUtilityBar from '../components/GovUtilityBar.vue'

const router = useRouter()

function goToLogin() {
  router.push('/login')
}

onMounted(() => {
  router.replace({ path: '/login', query: { focus: 'teacher' } })
})
</script>
